import { Button, FlexBox } from '@dixa/lib-shared-habla';
import type { SearchFilters } from 'lib-search-types';
import { useCallback, useMemo } from 'react';

import {
  convertFiltersObjectToString,
  convertFiltersStringToObject,
} from 'app/views/layout/views/search/utils/filters/convertFilters';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { ContactsFilterAttributes } from './components/filter/attributes/contactsFilterAttributes';
import { ContactsFilterCompany } from './components/filter/company/contactsFilterCompany';
import { ContactsFilterUserType } from './components/filter/userType/contactsFilterUserType';

export function ContactsFilters(): JSX.Element {
  const { params, setParam, unsetParam } =
    useAppSearchParams('/contacts/user/:id');

  const filters = useMemo(
    (): SearchFilters<'users'> =>
      params.filters
        ? convertFiltersStringToObject<'users'>(params.filters)
        : { strategy: 'all', filters: [] },
    [params.filters],
  );

  const handleChangeFilters = useCallback(
    (newFilters: SearchFilters<'users'>) => {
      const encoded = convertFiltersObjectToString(newFilters);

      if (encoded) {
        setParam('filters', encoded);
      } else {
        unsetParam('filters');
      }
    },
    [setParam, unsetParam],
  );

  const handleClearAll = useCallback(() => {
    unsetParam('filters');
  }, [unsetParam]);

  const hasActiveFilters = filters.filters.length > 0;

  return (
    <FlexBox gap="200" alignItems="center" flexWrap="wrap">
      <ContactsFilterUserType
        filters={filters}
        onChangeFilters={handleChangeFilters}
      />

      <ContactsFilterCompany
        filters={filters}
        onChangeFilters={handleChangeFilters}
      />

      <ContactsFilterAttributes
        filters={filters}
        onChangeFilters={handleChangeFilters}
      />

      {hasActiveFilters && (
        <Button variant="tertiary" onClick={handleClearAll}>
          Clear all
        </Button>
      )}
    </FlexBox>
  );
}
